import graphql from "babel-plugin-relay/macro";

const CheckUserNameQuery = graphql`
query CheckUserNameQuery($username:String!,$mobileNumber:String!){
   checkUsername(username:$username, mobileNumber:$mobileNumber){
    username
  }
}
`

export default CheckUserNameQuery;